document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-rotator").forEach(function (container) {
    const allProducts = Array.from(container.querySelectorAll(".rotator-product"));
    const visibleContainer = container.querySelector(".rotator-visible");

    const cycle = parseInt(container.dataset.cycle) || 4;
    const interval = parseInt(container.dataset.interval) || 5000;

    let index = 0;

    if (allProducts.length === 0 || !visibleContainer) return;

    function renderNextBatch() {
      visibleContainer.innerHTML = "";
      for (let i = 0; i < cycle; i++) {
        const currentIndex = (index + i) % allProducts.length;
        const clone = allProducts[currentIndex].cloneNode(true);
        visibleContainer.appendChild(clone);
      }
      index = (index + cycle) % allProducts.length;
    }

    renderNextBatch();
    setInterval(renderNextBatch, interval);
  });
});
